<template>
  <div id="administratorToolsMain" v-if="isOwner">
    <CRow id="administratorToolsHeaderRow" class="mt-3">
      <CCol id="administratorToolsHeaderCol" md="12" class="text-center">
        <h2 id="administratorToolsTitle" class="font-weight-medium text-dark">
          {{ $t('administratorTools') }}
        </h2>
        <h6 id="administratorToolsDescription" class="text-description">
          {{ $t('toolsSetting') }}
        </h6>
      </CCol>
    </CRow>
    <CCol id="administratorToolsAlertCol" col="12" style="margin-top: 1rem;">
      <CAlert id="administratorToolsAlert" color="info">
        <i class="fi fi-rr-info mr-1"></i> {{ $t('adminToolDesc') }}
      </CAlert>
    </CCol>
    <hr id="administratorToolsDivider" />
    <CRow id="administratorToolsCardRow" class="match-height">
      <CCol
        v-for="(item, index) in items"
        :key="item.objectId"
        :id="'administratorToolsCardColItem' + (index + 1)"
        md="6"
        lg="4"
        sm="6"
        class="d-flex align-items-stretch  mb-3"
      >
        <!-- เพิ่มคลาส d-flex flex-column h-100 เพื่อบีบให้ความสูงการ์ดทุกใบเท่ากันเป๊ะ -->
        <CCard id="administratorToolsCard" class="card-unlock bg-white d-flex flex-column h-100 w-100 mb-0" style="border-radius: 5px;">
          
          <!-- เพิ่ม flex-grow-1 เพื่อให้ Card Body ดันพื้นที่ทั้งหมดลงไปหา Footer -->
          <CCardBody id="administratorToolsCardBody" class="flex-grow-1">
            <CRow class="border-bottom align-items-center">
              <!-- ฝั่งซ้าย: แสดงหมายเลขเครื่อง -->
              <CCol id="administratorToolsCardHeaderCol" lg="8" sm="8" col="8">
                <h5
                  :id="'administratorToolsCardTitle' + (index + 1)"
                  class="font-weight-medium mb-0"
                  style="padding-top: calc(0.375rem + 1px); padding-bottom: calc(0.375rem + 1px); white-space: nowrap;"
                >
                  {{ $t('posNumber') }} - {{ item.posNumber }}
                </h5>
              </CCol>
              <!-- ฝั่งขวาบน: แสดง Badge ตาม posType -->
              <CCol lg="4" sm="4" col="4" class="text-right">
                <CBadge 
                  :style="getBadgeStyle(item.posType)"
                  style="font-size: 11px; padding: 6px 10px; border-radius: 6px; font-weight: 600;"
                >
                  {{ item.posType }}
                </CBadge>
              </CCol>
            </CRow>
            
            <table id="administratorToolsTable" class="table table-borderless mt-2 mb-0">
              <tr id="administratorToolsTableRow">
                <td id="administratorToolsDeviceNameLabel" style="width:50%">
                  <label class="text-left text-dark font-weight-medium mb-0 ">
                    {{ $t('deviceName') }}
                  </label>
                </td>
                <td :id="'administratorToolsDeviceNameValue' + (index + 1)" class="text-right">
                  <label class="text-dark color-input-unlock mb-0">
                    {{ item.deviceName }}
                  </label>
                </td>
              </tr>
              <tr id="administratorToolsLastSyncRow">
                <td id="administratorToolsLastSyncLabel">
                  <label class="text-left text-dark font-weight-medium mb-0">
                    {{ $t('lastSyncProduct') }}
                  </label>
                </td>
                <td :id="'administratorToolsLastSyncValue' + (index + 1)" class="text-right">
                  <label class="text-dark text-right color-input-unlock mb-0">
                    {{ item.lastSyncProduct }}
                  </label>
                </td>
              </tr>
              <tr id="administratorToolsVersionRow">
                <td id="administratorToolsVersionLabel">
                  <label class="text-left text-dark font-weight-medium mb-0">
                    {{ $t('version') }}
                  </label>
                </td>
                <td :id="'administratorToolsVersionValue' + (index + 1)" class="text-right">
                  <label class="text-dark text-right color-input-unlock mb-0">
                    {{ item.version }}
                  </label>
                </td>
              </tr>
              <tr id="administratorToolsStatusRow">
                <td id="administratorToolsStatusLabel">
                  <label class="text-left text-dark font-weight-medium mb-0">
                    {{ $t('posstatus') }}
                  </label>
                </td>
                <td :id="'administratorToolsStatusValue' + (index + 1)" class="text-right">
                  <CBadge
                    v-if="item.status === 'Online'"
                    :id="'administratorToolsStatusOnline' + (index + 1)"
                    color="success"
                    style="font-size: 12px; padding: 5px 10px; border-radius: 10px;"
                  >
                    {{ $t('isBeingToUsed') }}
                  </CBadge>
                  <CBadge
                    v-else
                    :id="'administratorToolsStatusOffline' + (index + 1)"
                    color="light"
                    style="font-size: 12px; padding: 5px 10px; border-radius: 10px;"
                  >
                    {{ $t('notInUse') }}
                  </CBadge>
                </td>
              </tr>
              <!-- แถวสำหรับดูข้อมูล T2P (เปลี่ยนปุ่มเป็น link เพื่อให้คลีนเข้ากับดีไซน์และไม่แย่งสายตา) -->
              <tr v-if="item.T2P" id="administratorToolsT2PBadgeRow">
                <td style="vertical-align: middle;">
                  <label class="text-left text-dark font-weight-medium mb-0">Tab to Pay </label>
                </td>
                <td class="text-right" style="vertical-align: middle;">
                  <CButton 
                    size="sm" 
                    color="link" 
                    class="text-info p-0 font-weight-bold"
                    style="font-size: 12px; text-decoration: none;"
                    @click="openT2PModal(item)"
                  >
                    <i class="fi fi-rr-eye mr-1"></i> {{ $t('viewInfo') }}
                  </CButton>
                </td>
              </tr>
            </table>
          </CCardBody>

          <!-- mt-auto บังคับให้ปุ่มแดงจมอยู่ล่างสุดของการ์ดเสมอ ไม่ว่าข้อมูลข้างบนจะสั้นหรือยาวกว่าใบอื่น -->
          <CCardFooter id="administratorToolsCardFooter" >
            <div id="administratorToolsUnlockDiv" v-if="item.enabled === true">
              <CButton
                :id="'administratorToolsUnlockButton' + (index + 1)"
                block
                class="btn-danger"
                style="border-radius: 8px;"
                v-on:click="showPopup(item)"
                v-if="item.uuid !== ''"
              >
                {{ $t('unlock') }}
              </CButton>
              <CButton
                :id="'administratorToolsDisabledUnlockButton' + (index + 1)"
                block
                color="secondary"
                style="border-radius: 8px;"
                disabled
                v-else
              >
                {{ $t('unlock') }}
              </CButton>
            </div>
            <div id="administratorToolsDisabledDiv" v-else>
              <CButton
                :id="'administratorToolsDisabledButton' + (index + 1)"
                block
                color="secondary"
                style="border-radius: 8px;"
                disabled
              >
                {{ $t('unlock') }}
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      id="administratorToolsModal"
      :show.sync="popupModal"
      centered
      :title="$t('unlock')"
      color="danger"
      :footer="footer"
    >
      <div id="administratorToolsModalBody" v-if="!isSuccess">
        <h4 id="administratorToolsModalTitle" class="text-center">
          {{ $t('unlockTitle', { posNumber: itemsUnlock.posNumber }) }}
        </h4>
        <p id="administratorToolsModalDescription" v-html="$t('unlockDescription')" class="text-center">
        </p>
      </div>
      <div id="administratorToolsModalSuccessBody" v-else>
        <h4 id="administratorToolsModalSuccessTitle" class="text-center">
          {{ $t('unlockSuccess') }}
        </h4>
      </div>
      <template #footer>
        <CRow id="administratorToolsModalFooterRow" class="justify-content-center col-md-12">
          <CCol id="administratorToolsModalConfirmCol" col="5" lg="4">
            <CButton
              id="administratorToolsModalConfirmButton"
              color="danger"
              block
              v-if="loadingButton === true && !isSuccess"
              v-on:click="getUnlockPOS"
            >
              {{ $t('unlock') }}
            </CButton>
            <CButton
              id="administratorToolsModalSavingButton"
              block
              color="danger"
              v-else-if="loadingButton === false && !isSuccess"
              disabled
            >
              <CSpinner id="administratorToolsModalSpinner" color="white" size="sm" /> {{ $t('save') }}
            </CButton>
          </CCol>
          <CCol id="administratorToolsModalSpacerCol" col="1" lg="2"></CCol>
          <CCol id="administratorToolsModalCancelCol" col="5" lg="4">
            <CButton
              id="administratorToolsModalCancelButton"
              block
              color="light"
              @click="popupModal = false"
              v-if="!isSuccess"
            >
              {{ $t('cancel') }}
            </CButton>
          </CCol>
          <CCol col="6">
          <CButton block color="light" v-if="isSuccess" @click="fetchPOSData">
            {{ $t('close') }}
          </CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>

    <CModal
      id="administratorToolsT2PModal"
      :show.sync="t2pModalShow"
      centered
      :title="$t('t2pInformation')"
      color="info"
    >
      <div v-if="selectedT2P" class="p-2">
        <div class="text-center mb-4">
          <CBadge :style="getBadgeStyle(selectedT2P.posType)">{{ selectedT2P.posType }}</CBadge>
          <h4 class="mt-2 font-weight-bold text-dark">{{ $t('posNumber') }} - {{ selectedT2P.posNumber }}</h4>
        </div>
        <table class="table table-striped table-bordered mb-0">
          <tbody>
            <tr>
              <td class="font-weight-medium text-dark" style="width: 40%">MID</td>
              <td class="text-muted">{{ selectedT2P.T2P.MID }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium text-dark">TID</td>
              <td class="text-muted">{{ selectedT2P.T2P.TID }}</td>
            </tr>
            <tr>
              <td class="font-weight-medium text-dark">{{ $t('t2pMerchantName') }}</td>
              <td class="text-muted">
                {{ $i18n.locale === 'th' ? selectedT2P.T2P.nameTH : selectedT2P.T2P.nameEN }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <div class="text-center w-100">
          <CButton color="secondary" style="min-width: 100px;" @click="t2pModalShow = false">
            {{ $t('closed') }}
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
  <div id="administratorToolsNoAccess" v-else>
    <access-data></access-data>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axios from '@/services/local'
import permis from '@/util/permission'
import { CBadge, CRow } from '@coreui/vue'

export default {
  data() {
    return {
      data: [],
      itemsUnlock: {},
      loadingButton: true,
      popupModal: false,
      footer: false,
      isSuccess: false,
      t2pModalShow: false,
      selectedT2P: null
    }
  },
  computed: {
    ...mapGetters(['shops', 'date', 'users', 'allPOS', 'isOwner']),
    isPermission() {
      return permis.findPermissionRead('setting', this.$route.path)
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    items() {
      let data = this.allPOS
      let detail = []
      for (let i = 0; i < data.length; i++) {
        let posNumber = ''
        let lastSyncProduct = ''
        let version = ''
        let uuid = ''
        let deviceName = ''
        let status = 'Offline'
        let posType = data[i].posType || 'POS'
        // เพิ่มตัวแปร T2P
        let T2P = null

        // ตรวจสอบเงื่อนไขว่าไม่เป็น undefined และไม่เป็นค่าว่าง
        if (data[i].T2P !== undefined && data[i].T2P !== null && data[i].T2P !== '') {
          let t2pData = data[i].T2P
          T2P = {
            MID: t2pData.MID || '-',
            TID: t2pData.TID || '-',
            // MID :'ddoiojkk',
            // TID : 'kjiojoik',
            nameEN: t2pData.nameEN || '-',
            nameTH: t2pData.nameTH || '-'
          }
        }

        if (data[i].posNumber !== undefined) {
          posNumber = data[i].posNumber
        }

        if (data[i].lastSyncProduct !== undefined) {
          lastSyncProduct = moment(String(data[i].lastSyncProduct)).format(
            'DD/MM/YYYY HH:mm'
          )
        }

        if (data[i].version !== undefined) {
          version = data[i].version
        }

        if (data[i].uuid !== undefined) {
          uuid = data[i].uuid
          status = 'Online'
        }

        if (data[i].deviceName !== undefined) {
          deviceName = data[i].deviceName
        }

        detail.push({
          posNumber: posNumber,
          lastSyncProduct: lastSyncProduct,
          version: version,
          uuid: uuid,
          deviceName: deviceName,
          objectId: data[i].objectId,
          status: status,
          enabled: data[i].enabled || false,
          posType: posType,
          T2P : T2P
        })
      }
      return detail
    },
  },
  mounted() {
    this.$store.dispatch('getAllPOS')
  },
  methods: {
    openT2PModal(item) {
      this.selectedT2P = item
      this.t2pModalShow = true
    },
    fetchPOSData() {
      this.$store.dispatch('getAllPOS').then(() => {
        this.popupModal = false
      })
    },
    showPopup(item) {
      this.itemsUnlock = item
      this.isSuccess = false
      this.popupModal = true
    },
    getUnlockPOS() {
      this.loadingButton = false
      this.loading = true
      const uid = `${localStorage.getItem('shopsUid')}`
      const objectId = this.itemsUnlock.objectId
      axios
        .get('/api/v1.0/' + uid + '/Shop/unlockpos/' + objectId)
        .then((res) => {
          if (res.data.error.code === 0) {
            this.$store.dispatch('getAllPOS')
          }
          this.isSuccess = true
          // this.popupModal = false
          this.loading = false
          this.loadingButton = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getBadgeStyle(type) {
      const styles = {
        'POS': {
          backgroundColor: '#e3f2fd', // ฟ้าพาสเทลอ่อน
          color: '#0d47a1',           // น้ำเงินเข้ม
        },
        'STAFF': {
          backgroundColor: '#e8f5e9', // เขียวมิ้นต์อ่อน
          color: '#1b5e20',           // เขียวเข้ม
        },
        'KIOSK': {
          backgroundColor: '#f3e5f5', // ม่วงลาเวนเดอร์อ่อน
          color: '#4a148c',           // ม่วงเข้ม
        },
        'QMANAGER': {
          backgroundColor: '#fff3e0', // ส้มชานมอ่อน
          color: '#e65100',           // ส้มเข้ม
        },
        'SEDC': {
          backgroundColor: '#e0f7fa', // ฟ้าเทอร์ควอยซ์อ่อน
          color: '#006064',           // เขียวแกมน้ำเงินเข้ม
        },
        'KDS': {
          backgroundColor: '#efebe9', // เทานม/น้ำตาลอ่อน
          color: '#4e342e',           // น้ำตาลเข้ม/ช็อกโกแลต
        },
      }

      const defaultStyle = {
        backgroundColor: '#eceff1', // เทาอ่อนคลีนๆ
        color: '#37474f',           // เทาเข้มชาร์โคล
      }

      const currentStyle = styles[type.toUpperCase()] || defaultStyle

      return {
        backgroundColor: currentStyle.backgroundColor,
        color: currentStyle.color,
        fontSize: '11px',
        padding: '6px 10px',
        borderRadius: '20px', 
        fontWeight: '600',
        letterSpacing: '0.5px',
        border: 'none'
      }
    },
  },
}
</script>

<style>
.card-unlock {
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 21 / 20%) !important;
}
</style>
